import { useEffect, useRef } from 'react';
import { AnimatePresence, motion } from 'motion/react';

import { useSession } from '@/components/livekit/app/session-provider';
import { SessionView } from '@/components/livekit/app/session-view';
import { WelcomeView } from '@/components/livekit/app/welcome-view';

import { useRoomContext } from '@livekit/components-react';

const MotionWelcomeView = motion.create(WelcomeView);
const MotionSessionView = motion.create(SessionView);

const VIEW_MOTION_PROPS = {
  variants: {
    visible: {
      opacity: 1,
    },
    hidden: {
      opacity: 0,
    },
  },
  initial: 'hidden',
  animate: 'visible',
  exit: 'hidden',
  transition: {
    duration: 0.5,
    ease: 'linear',
  },
};

export function ViewController() {
  const room = useRoomContext();
  const isSessionActiveRef = useRef(false);
  const { appConfig, isSessionActive, startSession, endSession } = useSession();

  // animation handler holds a reference to stale isSessionActive value
  isSessionActiveRef.current = isSessionActive;

  useEffect(() => {
    return () => {
      if (isSessionActive) {
        endSession();
      }
    };
  }, []);

  // disconnect room after animation completes
  const handleAnimationComplete = () => {
    if (!isSessionActiveRef.current && room.state !== 'disconnected') {
      room.disconnect();
    }
  };

  return (
    <AnimatePresence mode="wait">
      {/* Welcome screen */}
      {!isSessionActive && (
        <MotionWelcomeView
          className="place-content-center"
          key="welcome"
          {...VIEW_MOTION_PROPS}
          startButtonText={'Start test call'}
          onStartCall={(agentId: string, metadata: Record<string, string>) =>
            startSession(agentId, metadata)
          }
        />
      )}
      {/* Session view */}
      {isSessionActive && (
        <MotionSessionView
          key="session-view"
          {...VIEW_MOTION_PROPS}
          appConfig={appConfig}
          onAnimationComplete={handleAnimationComplete}
        />
      )}
    </AnimatePresence>
  );
}
